import React from 'react';
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  HStack,
  IconButton,
  Text,
  VStack,
  useDisclosure,
} from '@chakra-ui/react';
import { FiMenu } from 'react-icons/fi';
import SaktiSidebar from '../components/SaktiSidebar';
import SaktiSyncPanel from '../components/SaktiSyncPanel';
import SaktiDataViewer from '../components/SaktiDataViewer';
import { useSaktiSync } from '../hooks/useSaktiSync';
import { useSaktiDataViewer } from '../hooks/useSaktiDataViewer';
import { SAKTI_UI_SIZE } from '../uiSizes';

const SaktiConfigurationPage: React.FC = () => {
  const sync = useSaktiSync();
  const viewer = useSaktiDataViewer();

  const {
    isOpen: isMobileSidebarOpen,
    onOpen: onMobileSidebarOpen,
    onClose: onMobileSidebarClose,
  } = useDisclosure();

  return (
    <Box minH="100vh" bg="#ECEEF1">
      <Flex align="stretch">
        {/* Desktop Sidebar */}
        <Box display={{ base: 'none', xl: 'block' }}>
          <SaktiSidebar activeMenu="configuration" />
        </Box>

        {/* Mobile Sidebar Drawer */}
        <Drawer
          isOpen={isMobileSidebarOpen}
          placement="left"
          onClose={onMobileSidebarClose}
          size="xs"
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton zIndex={10} color="gray.500" />
            <DrawerBody p={0}>
              <SaktiSidebar activeMenu="configuration" />
            </DrawerBody>
          </DrawerContent>
        </Drawer>

        <Box flex={1} p={SAKTI_UI_SIZE.pagePadding} minW={0}>
          <VStack align="stretch" spacing={SAKTI_UI_SIZE.sectionGap}>
            <HStack spacing={3} align="center">
              <IconButton
                aria-label="Open menu"
                icon={<FiMenu />}
                variant="outline"
                bg="white"
                display={{ base: 'flex', xl: 'none' }}
                onClick={onMobileSidebarOpen}
              />
              <Text
                fontSize={SAKTI_UI_SIZE.pageTitle}
                fontWeight="bold"
                color="gray.900"
                lineHeight="shorter"
              >
                Configuration
              </Text>
            </HStack>

            <SaktiSyncPanel
              entities={sync.entities}
              loadingEntities={sync.loadingEntities}
              entitiesError={sync.entitiesError}
              selected={sync.selected}
              job={sync.job}
              isSyncing={sync.isSyncing}
              onToggleEntity={sync.toggleEntity}
              onSelectAll={sync.selectAllEntities}
              onClearSelection={sync.clearSelection}
              onSyncAll={sync.syncAll}
              onSyncSelected={sync.syncSelected}
              onReloadEntities={sync.reloadEntities}
            />

            <SaktiDataViewer
              tables={viewer.tables}
              loadingTables={viewer.loadingTables}
              tablesError={viewer.tablesError}
              selectedTable={viewer.selectedTable}
              columns={viewer.columns}
              rows={viewer.rows}
              pagination={viewer.pagination}
              loadingRows={viewer.loadingRows}
              rowsError={viewer.rowsError}
              searchInput={viewer.searchInput}
              sortBy={viewer.sortBy}
              sortDir={viewer.sortDir}
              qualifiedName={viewer.qualifiedName}
              onSelectTable={viewer.selectTable}
              onSearchChange={viewer.setSearchInput}
              onToggleSort={viewer.toggleSort}
              onPageChange={viewer.goToPage}
            />
          </VStack>
        </Box>
      </Flex>
    </Box>
  );
};

export default SaktiConfigurationPage;
